// src/components/ui/spinner/index.tsx
import { Box, CircularProgress, CircularProgressProps } from '@mui/material'

type SpinnerProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit'
  className?: string
} & Omit<CircularProgressProps, 'size' | 'color'>

// サイズ値のマッピング
const sizeMap = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 48,
  xl: 64,
}

export const Spinner = ({
  size = 'md',
  color = 'primary',
  className = '',
  ...rest
}: SpinnerProps) => {
  const muiSize = sizeMap[size]

  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      className={className}>
      <CircularProgress
        size={muiSize}
        color={color}
        {...rest}
      />
    </Box>
  )
}
